import { sm4 } from 'sm-crypto'

const sm4key = '1q2w3e4r5t6y7u8i'
// ASCII转Hex
function asciiToHex(str) {
  return Array.from(str)
    .map(c =>
      c
        .charCodeAt(0)
        .toString(16)
        .padStart(2, '0')
    )
    .join('')
}
// Hex转Base64
function hexToBase64(hexString) {
  return btoa(
    hexString
      .match(/\w{2}/g)
      .map(h => String.fromCharCode(parseInt(h, 16)))
      .join('')
  )
}
// bse64转Hex
function base64ToHex(base64) {
  // 1. Base64 解码为二进制字符串
  const binaryStr = atob(base64)
  // 2. 转换为 Hex
  let hex = ''
  for (let i = 0; i < binaryStr.length; i++) {
    const charCode = binaryStr.charCodeAt(i)
    // 将字符码转换为 2 位 Hex，并补零（如 'a' -> '0a'）
    hex += charCode.toString(16).padStart(2, '0')
  }
  return hex
}
function handleEncrpty(val) {
  let hexkey = asciiToHex(sm4key)
  return hexToBase64(sm4.encrypt(val, hexkey))
}
function handleDecrpty(val) {
  let hexkey = asciiToHex(sm4key)
  return sm4.decrypt(base64ToHex(val), hexkey)
}
export { handleEncrpty, handleDecrpty }
